<template>
    <div class="synchronized-video-seek-bar">
        <b-form-slider
            ref="videoSeekBar"
            orientation="horizontal"
            :value="seekValue"
            :min="0"
            :step="1"
            :disabled="disabled"
            :class="{ 'slider-disabled': disabled }"
            class="video-seek-bar"
            :max="1000"
            @change="seekChangeHandler"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'SynchronizedVideoSeekBar',
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            seekBar_currentTimeCode_s: state => state.video.seekBar_currentTimeCode_s
        }),
        ...mapGetters({
            videoLength_s: 'video/videoLength_s'
        }),
        seekValue() {
            if (!this.videoLength_s) return 0

            return (this.seekBar_currentTimeCode_s / this.videoLength_s) * 1000
        }
    },
    methods: {
        seekChangeHandler({ newValue }) {
            const timecode = (this.videoLength_s * newValue) / 1000

            this.$store.dispatch('video/seek', { timecode })
            this.$store.commit('video/isFertilizationCheck', false)
        }
    }
}
</script>

<style lang="scss">
.synchronized-video-seek-bar {
    position: relative;

    .video-seek-bar {
        width: 100%;

        .slider {
            width: 100%;
        }

        .slider-track {
            width: 100%;
            height: 0.5rem;
            border-radius: 2rem;
            background-image: none;
            background-color: $dark-2;

            .slider-selection {
                background-image: none;
                background-color: $blue;
            }
        }
        .slider-handle {
            background: $blue;
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            border: 0.4rem solid $dark-4;
            margin-top: -0.2rem;
            box-shadow: $handle-shadow;
            cursor: pointer;
            z-index: 20;

            &:hover {
                border-color: $dark-5;
            }
        }
    }

    .slider-disabled {
        .slider-handle,
        .slider-selection,
        .slider-track {
            background-image: none !important;
            background-color: $dark-2 !important;
        }
    }
}
</style>
